import moment from 'moment';

function Task(name, options) {
  this.name = name;
  const opts = options || {};

  this.autodone = opts.autodone || null;
  this.tags = opts.tags || [];
  this.defer = opts.defer || null;
  this.due = opts.due || null;
  this.done = opts.done || null;
  this.estimate = opts.estimate || null;
  this.flagged = opts.flagged || null;
  this.parallel = opts.estimate || true;
  this.repeatMethod = opts.estimate || null;
  this.repeatRule = opts.estimate || null;

  if (!['fixed', 'start-after-completion', 'due-after-completion', null].some(value => this.repeatMethod === value)) {
    throw Error('repeatMethod must be one of: "fixed", "start-after-completion", "due-after-completion", null');
  }
}

const isBoolean = value => typeof value === 'boolean';
const formatDate = date => moment(date).format('YYYY-MM-DD');

Task.prototype.serialize = function serialize() {
  const components = [
    this.name,
    this.tags.length ? ` @tags(${this.tags.join(', ')})` : '',
    isBoolean(this.autodone) ? ` @autodone(${this.autodone})` : '',
    this.defer ? ` @defer(${formatDate(this.defer)})` : '',
    this.due ? ` @due(${formatDate(this.due)} 9pm)` : '',
    this.done ? ` @done(${formatDate(this.done)})` : '',
    isBoolean(this.estimate) ? ` @estimate(${this.estimate})` : '',
    isBoolean(this.parallel) ? ` @parallel(${this.parallel})` : '',
    this.repeatMethod !== null ? ` @repeat-method(${this.repeatMethod})` : '',
    isBoolean(this.repeatRule) ? ` @parallel(${this.repeatRule})` : '',
    this.flagged ? ' @flagged' : '',
  ];

  return components.join('').trim();
};

export default {
  Task,
};
